const tableConstantsAr = {
  actions: 'الإجراءات',
  rowsPerPageLabel: 'عدد الصفوف لكل صفحة:',
  tableColumnPages: 'الصفحات',
  tableColumnActions: 'الإجراءات',
  tableRowsTotal: 'المجموع',
  of:'من'
};
export default tableConstantsAr;
